import React from 'react';

import { observer } from 'mobx-react';

import { useCheckbox } from '@react-aria/checkbox';
import { useToggleState } from '@react-stately/toggle';

import type { IFieldProps } from 'bz-core-controls/controls/form/field/field/IFieldProps';

export interface IProps extends React.PropsWithChildren, Omit<IFieldProps, 'onChange'> {
  isSelected?: boolean;

  onChange?: (isChecked: boolean) => void;
}

const ClickCheckbox: React.FC<IProps> = observer((props) => {
  const { children } = props;

  const ref = React.useRef<HTMLInputElement>(null);

  const state = useToggleState(props);
  const { inputProps } = useCheckbox({ ...props }, state, ref);

  return (
    <label className="mb-1 flex items-center gap-1 text-base font-medium">
      <input
        {...inputProps}
        ref={ref}
        className="mr-3 rounded border-gray-400 text-clickBlue focus:ring-clickBlue"
      />
      {children}
    </label>
  );
});

ClickCheckbox.displayName = 'ClickCheckbox';

export default ClickCheckbox;
